import * as React from 'react'
import Select from 'react-select'
import './Select.scss'

type AutoSuggestProps = Pick<
  Select['props'],
  'options' | 'placeholder' | 'onChange'
> & {
  searchPromptText: string
}

const AutoSuggest: React.FC<AutoSuggestProps> = ({
  options,
  placeholder,
  searchPromptText,
  onChange,
}) => (
  <Select
    clearable={false}
    backspaceRemoves={false}
    {...{ searchPromptText, onChange, placeholder, options }}
  />
)

export default AutoSuggest
